export default "__VITE_ASSET___fgX2Rn0__"